import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fr } from 'date-fns/locale';
import 'styles/quotedate.css';

const QuoteDate = (
    {
        selectedDates,
        setSelectedDates,
        onChange = () => {},
    }
) => {

    const onChangeHandle = (dates) => {
      setSelectedDates(dates);
      onChange(dates);
    }

    registerLocale('fr', fr);

    return (
      <div
        className='QuoteDate'
      >
        <div>DATE(S)</div>
        <DatePicker
          selectedDates={selectedDates}
          selectsMultiple
          openToDate={selectedDates?.length > 0 ? selectedDates[0] : new Date()}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          locale="fr"
          dateFormat="dd/MM/yyyy" 
          onChange={onChangeHandle}
          shouldCloseOnSelect={false}
          disabledKeyboardNavigation
        />        
      </div>
    );
  };
  
  export default QuoteDate;